import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

type BrowserMetaDataProp = {
    currentUrl?: string;
    title: string;
    quote?: string;
    description?: string;
    image?: string;
    hashtag?: string;
    locale: string;
}

export const Title = ({
  sectionTitle,
  subTitle
} : {sectionTitle: string, subTitle?: string}) : React.ReactElement => {
  const intl = useIntl();
  return (
    <Helmet>
      <title>
        {intl.formatMessage({ id: 'general.page-title' }, { sectionTitle: `${sectionTitle} ${subTitle ?  ' • ' : ''}`,
          subTitle: subTitle })}
      </title>
    </Helmet>
  );
};

// social media sites scrapes the meta tag of a web page to display the necessary information.
// BrowserMetaData component data will be required later when sharing Activities to other sites. Significannt for SEO as well.
const BrowserMetaData = ({
  currentUrl,
  title,
  quote,
  description,
  image,
  hashtag,
  locale
} : BrowserMetaDataProp): React.ReactElement=>{

  return (
    <Helmet>
      <meta property="url" content={currentUrl} />
      <meta property="title" content={title} />
      <meta property="quote" content={quote} />
      <meta name="description" content={description} />
      <meta property="image" content={image} />
      <meta property="og:locale" content={locale} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:quote" content={quote} />
      <meta property="og:hashtag" content={hashtag} />
      <meta property="og:image" content={image} />
      <meta content="image/*" property="og:image:type" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content="ARK" />
      <meta property="og:description" content={description} />
    </Helmet>
  );
};

export default BrowserMetaData;
